// What the API says went wrong: error responses are { error, params?, fields?, requestId? }, with a code and never any
// wording. These lists copy tristar-corp-api's Src/Models/ApiErrorCodes.ts: add a code there first, then here, then its
// text in src/i18n/en/errors.ts (the catalogue's type won't compile without it).
export const ApiErrorCodes = [
    'bad_request',
    'validation_failed',
    'unauthorized',
    'forbidden',
    'not_found',
    'method_not_allowed',
    'conflict',
    'too_many_requests',
    'unavailable',
    'maintenance',
    'server_error',

    'username_in_use',
    'email_in_use',
    'incorrect_password',
    'reauthentication_required',
    'session_ended',
    'account_disabled',
    'cannot_delete_self',
    'cannot_delete_admin',
    'invalid_code',
    'mfa_off',
    'authenticator_already_set_up',
    'email_codes_already_on',
    'upload_expired',
    'image_rejected',

    'sku_in_use',
    'version_exists',
    'product_has_licenses',
    'current_version',
    'version_has_no_files',
    'current_version_track',
    'version_delisted',
    'last_file_of_current_version',
    'file_not_uploaded',
    'image_not_uploaded',
    'image_in_use',
    'no_license',
    'product_has_no_images',
    'not_a_pdf',

    'license_key_in_use',
    'unknown_product',
    'not_a_review_license',
    'not_a_press_inquiry',
    'review_license_issued',

    'license_required',
    'ticket_closed',
    'ticket_already_in_state',
    'reason_not_allowed',
    'turnstile_failed',

    'not_for_sale',
    'shop_closed',
    'provider_unavailable',
    'address_not_taxable',

    // The mailing list
    'campaign_sent',
    'test_required'
] as const;

export type ApiErrorCode = typeof ApiErrorCodes[number];

export const FieldErrorCodes = [
    'required',
    'invalid',
    'invalid_format',
    'too_long',
    'too_large',
    'out_of_range',
    'not_allowed',
    'duplicate',
    'conflict',
    'not_early_access_user',
    'dev_version'
] as const;

export type FieldErrorCode = typeof FieldErrorCodes[number];

// Numbers, booleans, identifiers and ISO dates: never text a user wrote.
export type ErrorParams = { [name: string]: string | number | boolean };

export interface FieldError {
    // The request body's field, with [index] for arrays: prices[1].amount.
    field: string;
    error: FieldErrorCode;
    params?: ErrorParams;
}

// The codes that only repeat what the status says: a page's own wording for the status is better than these.
export const GenericErrorCodes: ApiErrorCode[] = [
    'bad_request', 'unauthorized', 'forbidden', 'not_found', 'method_not_allowed', 'conflict', 'too_many_requests',
    'unavailable', 'server_error'
];

export function isApiErrorCode(value: unknown): value is ApiErrorCode {
    return (ApiErrorCodes as readonly unknown[]).includes(value);
}

export function isFieldErrorCode(value: unknown): value is FieldErrorCode {
    return (FieldErrorCodes as readonly unknown[]).includes(value);
}
